import { ConfigurationType } from 'data/types';
import {
  isAirHandlerAvailabilityUnknown,
  isPositionedWithZoneItems
} from 'utils/air-handler-availability';
import { condenserValidSystemCount } from 'utils/air-handler-pool-tuples';

export type ConfigurationSystemAvailability = 'unknown' | 'none' | 'available';

// Whether anything can be built from this configuration as drawn. 'none' as
// soon as one positioned condenser with zoned spaces has a known pool holding
// no system at all — no combination can include it, so every step after
// zoning is wasted effort until the zones change. 'unknown' while a pool is
// still owed; 'available' once every pool is known and non-empty.
export function getConfigurationSystemAvailability(
  configuration: Pick<ConfigurationType, 'condensers'> | undefined
): ConfigurationSystemAvailability {
  const condensers = (configuration?.condensers ?? []).filter(
    isPositionedWithZoneItems
  );
  if (condensers.length === 0) return 'unknown';
  const known = condensers.filter(
    (condenser) => !isAirHandlerAvailabilityUnknown(condenser)
  );
  if (known.some((condenser) => condenserValidSystemCount(condenser) === 0)) {
    return 'none';
  }
  return known.length === condensers.length ? 'available' : 'unknown';
}

export const hasNoSystemsForConfiguration = (
  configuration: Pick<ConfigurationType, 'condensers'> | undefined
): boolean => getConfigurationSystemAvailability(configuration) === 'none';
